import { Message } from "@arco-design/web-react";
let csrf = "";
const pendingIntents = new Map<string, string>();
export const setCsrf = (value: string) => {
  if (csrf !== value) pendingIntents.clear();
  csrf = value;
};
export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
    public code?: string,
    public detail?: any,
  ) {
    super(message);
  }
}
export async function api<T = any>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const headers = new Headers(init.headers);
  const retryable =
    init.method === "POST" &&
    (path === "/operations" ||
      /^\/conversations\/[^/]+\/messages$/.test(path) ||
      /^\/plans\/[^/]+\/confirm$/.test(path) ||
      /^\/planning\/[^/]+\/accept$/.test(path));
  const intent = retryable
    ? `${csrf}:${path}:${String(init.body || "")}`
    : null;
  if (init.body && !(init.body instanceof FormData))
    headers.set("Content-Type", "application/json");
  if (init.method && !["GET", "HEAD"].includes(init.method)) {
    headers.set("X-CSRF-Token", csrf);
    if (!headers.has("Idempotency-Key")) {
      const key = (intent && pendingIntents.get(intent)) || crypto.randomUUID();
      headers.set("Idempotency-Key", key);
      if (intent) pendingIntents.set(intent, key);
    }
  }
  const response = await fetch(`/api/v1${path}`, {
    ...init,
    headers,
    credentials: "same-origin",
  });
  const data = await response.json();
  // Preserve the same intent after a lost/ambiguous response. A user retry cannot duplicate a committed write.
  if (
    intent &&
    response.status < 500 &&
    pendingIntents.get(intent) === headers.get("Idempotency-Key")
  )
    pendingIntents.delete(intent);
  if (!response.ok)
    throw new ApiError(
      response.status,
      data.error || "请求失败",
      data.code,
      data.detail,
    );
  return data;
}
export const post = <T = any>(path: string, data: unknown = {}) =>
  api<T>(path, { method: "POST", body: JSON.stringify(data) });
export function showError(error: unknown) {
  Message.error(error instanceof Error ? error.message : "操作失败，请重试");
}
export const upload = (file: File | Blob, targetId?: string) => {
  const form = new FormData();
  form.append(
    "file",
    file,
    file instanceof File ? file.name : "recording.webm",
  );
  return api(`/media${targetId ? `?targetId=${targetId}` : ""}`, {
    method: "POST",
    body: form,
  });
};
